import React, { Component } from "react";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import { newPostPlaceholderText } from "../utils/placeholder";
import PostEditor from "../components/PostEditor";
import { Link } from "react-router-dom";
import {
    DialogActions,
    DialogContent,
    AppBar,
    Typography,
    Button,
    Toolbar
} from "material-ui";
import withMobileDialog from "material-ui/Dialog/withMobileDialog";
import { submitPost, updatePost } from "../actions/post.actions";
import UserAvatar from "../components/UserAvatar";
import Dialog from "../components/MobileScrollingDialog";
import { red } from "material-ui/colors";
import ChooseLanguage from "../components/ChooseLanguage";

const styleSheet = theme => ({
    mainContainer: {
        maxWidth: 600,
        padding: theme.spacing.unit
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120
    },
    flex: {
        flex: 1,
        marginLeft: theme.spacing.unit
    },
    error: {
        color: red[500],
        marginTop: -2
    }
});

class NewPostDialog extends Component {
    state = {
        languageDialogOpen: false
    };

    dispatch(action) {
        this.props.dispatch(action);
    }

    learningLanguages = () => {
        const { languages } = this.props.userSettings;
        return languages
            .filter(language => language.isLearning)
            .map(l => l.language);
    };

    submitPost = () => {
        this.dispatch(submitPost({ post: this.props.post }));
    };

    handleRequestClose = () => {
        this.props.onRequestClose();
    };

    handleSelectLanguageChange = ({ target: { value } }) => {
        this.dispatch(updatePost({ language: value }));
    };

    renderChooseLanguageSelect() {
        const { post, classes } = this.props;
        const learningLanguages = this.learningLanguages();

        return (
            <ChooseLanguage
                className={classes.formControl}
                learningLanguages={learningLanguages}
                language={post.language}
                handleSelectLanguageChange={this.handleSelectLanguageChange}
            />
        );
    }

    onPostChange = newBody => {
        this.dispatch(updatePost({ body: newBody }));
    };

    componentDidUpdate(prevProps) {
        if (this.editor && !prevProps.open && this.props.open) {
            if (this.editor) {
                this.editor.focus();
            }
        }
    }

    renderPostContent() {
        const { t, post, classes } = this.props;
        return (
            <DialogContent>
                {this.renderChooseLanguageSelect()}
                <div className={classes.mainContainer}>
                    <PostEditor
                        innerRef={r => {
                            this.editor = r;
                        }}
                        onChange={this.onPostChange}
                        text={post.body}
                        placeholder={t(newPostPlaceholderText)}
                    />
                </div>
            </DialogContent>
        );
    }

    renderSubmitSuccess() {
        const { t, classes } = this.props;
        return (
            <DialogContent>
                <div className={classes.mainContainer}>
                    <Typography type="body1">
                        {t(
                            "postDialog.Congratulations, your post was submitted successfully!"
                        )}
                    </Typography>
                </div>
            </DialogContent>
        );
    }

    renderDialogContent() {
        const { submitSuccess } = this.props;
        if (submitSuccess) {
            return this.renderSubmitSuccess();
        }
        return this.renderPostContent();
    }

    validatePost(body) {
        const { t } = this.props;
        body = body.trim();
        if (body.length === 0) {
            return { valid: false };
        }
        if (body.length > 4000) {
            return {
                valid: false,
                error: t("postDialog.A post must be 4000 characters or less")
            };
        }
        return { valid: true };
    }

    renderDialogActions() {
        const {
            t,
            post,
            classes,
            createRequest: { requesting },
            submitSuccess
        } = this.props;

        const { valid, error } = this.validatePost(post.body);

        const closeButton = (
            <Button onClick={this.handleRequestClose}>
                {t("postDialog.Close")}
            </Button>
        );
        const submitButton = (
            <Button onClick={this.submitPost} disabled={requesting || !valid}>
                {t("postDialog.Submit")}
            </Button>
        );
        const gotoPostButton = (
            <Button
                color="accent"
                component={Link}
                onClick={this.handleRequestClose}
                to={`/posts/${post.id}`}>
                {t("postDialog.Go to your post")}
            </Button>
        );
        return (
            <DialogActions>
                {error &&
                    <Typography className={classes.error} type="body1">
                        {error}
                    </Typography>}
                {closeButton}
                {submitSuccess ? gotoPostButton : submitButton}
            </DialogActions>
        );
    }

    renderTitle() {
        const {
            t,
            userSettings: { avatarURL, displayName },
            classes,
            post,
            submitSuccess
        } = this.props;
        let title;

        if (submitSuccess) {
            title = t("postDialog.Post submitted");
        } else if (post.id) {
            title = t("postDialog.Edit post");
        } else {
            title = t("postDialog.New post");
        }
        return (
            <AppBar
                className={classes.appBar}
                position="static"
                style={{ backgroundColor: "white" }}
                elevation={0}>
                <Toolbar>
                    <UserAvatar
                        avatarURL={avatarURL}
                        displayName={displayName}
                    />
                    <Typography
                        className={classes.flex}
                        type="title"
                        color="inherit">
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }
    render() {
        const { fullScreen, open } = this.props;

        return (
            <Dialog
                size="xs"
                fullWidth={true}
                fullScreen={fullScreen}
                ignoreBackdropClick={true}
                open={open}
                onClose={this.handleRequestClose}>
                {this.renderDialogContent()}
                {this.renderDialogActions()}
            </Dialog>
        );
    }
}

NewPostDialog.propTypes = {
    open: PropTypes.bool,
    onRequestClose: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    userSettings: PropTypes.object.isRequired,
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,
    createRequest: PropTypes.object.isRequired,
    post: PropTypes.object.isRequired,
    submitSuccess: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired
};

NewPostDialog.defaultProps = {
    open: false,
    fullScreen: PropTypes.bool.isRequired,
    onRequestClose: () => {}
};

function mapStateToProps({
    userSettings,
    createEditPost: { post, createRequest, submitSuccess }
}) {
    return {
        userSettings,
        post,
        createRequest,
        submitSuccess
    };
}

export default withMobileDialog({ breakpoint: "xs" })(
    wrapComponent(NewPostDialog, styleSheet, mapStateToProps)
);



// WEBPACK FOOTER //
// ./src/containers/NewPostDialog.jsx